import React from 'react';
import { motion } from 'framer-motion';
import { Thread } from '../types';
interface MessagesViewProps {
  threads: Thread[];
  onSelectThread: (thread: Thread) => void;
}
export function MessagesView({
  threads,
  onSelectThread
}: MessagesViewProps) {
  return <div className="p-4" data-id="element-256">
      <h2 className="text-2xl font-bold text-zinc-900 mb-6 px-2" data-id="element-257">Messages</h2>

      <div className="space-y-2" data-id="element-258">
        {threads.map((thread, index) => <motion.button key={thread.id} initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: index * 0.1
      }} onClick={() => onSelectThread(thread)} className="w-full flex items-center gap-4 p-3 rounded-2xl hover:bg-white hover:shadow-sm transition-all duration-200" data-id="element-259">
            <div className="relative" data-id="element-260">
              <img src={thread.user.photos[0]} alt={thread.user.name} className="w-14 h-14 rounded-full object-cover border-2 border-white shadow-sm" data-id="element-261" />
              {thread.unreadCount > 0 && <span className="absolute -top-1 -right-1 w-5 h-5 bg-rose-500 rounded-full border-2 border-white flex items-center justify-center text-[10px] font-bold text-white" data-id="element-262">
                  {thread.unreadCount}
                </span>}
            </div>

            <div className="flex-1 text-left overflow-hidden" data-id="element-263">
              <div className="flex justify-between items-baseline mb-1" data-id="element-264">
                <h3 className="font-bold text-zinc-900" data-id="element-265">{thread.user.name}</h3>
                <span className="text-xs text-zinc-400" data-id="element-266">
                  {thread.lastMessage.timestamp}
                </span>
              </div>
              <p className={`text-sm truncate ${thread.unreadCount > 0 ? 'text-zinc-900 font-medium' : 'text-zinc-500'}`} data-id="element-267">
                {thread.lastMessage.isMe && <span className="text-zinc-400" data-id="element-268">You: </span>}
                {thread.lastMessage.text}
              </p>
            </div>
          </motion.button>)}
      </div>
    </div>;
}